// extracted by mini-css-extract-plugin
export default {"UserInfo":"UserInfo__UserInfo___Bec0g","user":"UserInfo__user___Q1lp5","icon":"UserInfo__icon___v63vK","name":"UserInfo__name___dUnmC","context":"UserInfo__context___xPFn_"};